import {h} from 'preact';
import {CopilotView} from "./MenuCopilot";
import constants from "../constants";
import LoadingSpinner from "./LoadingSpinner";
import {useCallback, useEffect, useState} from "preact/hooks";
import aiService from "../service/aiService";
import store from "../store";

interface MenuCopilotDesignTipsProps {
  visible: boolean;
  setView: (view: CopilotView) => void;
  setCurrentCount: (view: number) => void;
  setCountLimit: (view: number) => void;
  isPaidMember: boolean;
  designId: string;
}

export default function MenuCopilotDesignTips({
                                                isPaidMember,
                                                visible,
                                                setView,
                                                setCurrentCount,
                                                setCountLimit,
                                                designId
                                              }: MenuCopilotDesignTipsProps) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const populateData = useCallback((data: string) => {
    const botResponse = data ? JSON.parse(data).response : "";
    const newData = botResponse ? JSON.parse(botResponse.replace(/\n/g, '').replace("json", "")).design_tips : [];
    if (newData.length > 0) {
      setData(newData);
    }
  }, []);

  const fetchDesignTips = useCallback(() => {
    if (!visible || !isPaidMember) return;

    setLoading(true);
    const {memberId, designId} = store.getState();
    aiService.designTips(designId, memberId).then(resp => {
      setLoading(false);
      const {data, currentCount, countLimit} = resp.data;

      window.localStorage.setItem("bot-design-tips-" + designId, data);
      setCurrentCount(currentCount);
      setCountLimit(countLimit);

      populateData(data);
    });
  }, [visible, isPaidMember]);

  useEffect(() => {
    const localData = window.localStorage.getItem("bot-design-tips-" + designId);
    if (localData) {
      populateData(localData);
    } else {
      if (data.length === 0) {
        fetchDesignTips();
      }
    }
  }, [visible, isPaidMember, data]);

  return <section className={`bot-section ${visible ? "visible" : ""}`}>
    <header>
      <button className={"back"} onClick={() => setView(CopilotView.Overview)}>
        <svg>
          <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-back-icon"}/>
        </svg>
      </button>

      <svg className={"icn"}>
        <use xlinkHref={constants.appPrefix + "/svg/icons.svg#designtips"}/>
      </svg>

      <h3>
        Design Tips
        <div className={"beta"}>Beta</div>
      </h3>

      <div className={"left"}>
        <button className={"refresh"} onClick={fetchDesignTips}>
          <svg>
            <use xlinkHref={constants.appPrefix + "/svg/icons.svg#refresh"}/>
          </svg>
        </button>
      </div>
    </header>

    <>
      {loading && <LoadingSpinner/>}
      {!loading && <>
        {data.length > 0 && <p>
          Here are some design tips to maximize your menu:
        </p>}
        {data.map(it => <p>{it}</p>)}
      </>}
    </>
  </section>
}
